interface BaseIconProps {
  size?: number;
  color?: string;
  children?: React.ReactNode;
  extraStyle?: string;
}
const BaseIcon = ({ size, color, children, extraStyle }: BaseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 16 16"
      className={extraStyle}
    >
      {children}
    </svg>
  );
};

type IconProps = Omit<BaseIconProps, 'children'>;

export const CheckIcon = ({ size = 20, color = '#268e52' }: IconProps) => (
  <BaseIcon size={size} color={color}>
    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
  </BaseIcon>
);

export const CloseIcon = ({ size = 20, color = '#b12009' }: IconProps) => (
  <BaseIcon size={size} color={color}>
    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
  </BaseIcon>
);

export const ExclamationTriangle = ({
  size = 24,
  color = '#41464b',
  extraStyle,
}: IconProps) => (
  <BaseIcon size={size} color={color} extraStyle={extraStyle}>
    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
  </BaseIcon>
);

export const ExpandIcon = ({ size = 24, color = '#41464b' }: IconProps) => (
  <BaseIcon size={size} color={color}>
    <path d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8ZM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2ZM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10Z"></path>
  </BaseIcon>
);

export const ArrowDownIcon = ({ size = 24, color = '#41464b' }: IconProps) => (
  <BaseIcon size={size} color={color}>
    <g clipPath="url(#clip0_511:626)">
      <path
        d="M12.0157 14.9273C13.2413 14.2119 14.2117 13.2415 14.9271 12.0159C15.6424 10.79 16 9.45181 16 8.00024C16 6.54882 15.6424 5.21021 14.9271 3.98456C14.2118 2.75883 13.2414 1.78844 12.0157 1.07303C10.7899 0.357592 9.45129 -2.86253e-07 7.99998 -3.49692e-07C6.5486 -4.13134e-07 5.21021 0.357701 3.98434 1.07292C2.75873 1.78829 1.78833 2.75869 1.07289 3.98441C0.357591 5.21021 -3.65259e-05 6.54871 -3.65893e-05 8.00009C-3.66528e-05 9.45148 0.357591 10.7901 1.07288 12.0158C1.78807 13.2415 2.75872 14.2119 3.98434 14.9272C5.2101 15.6424 6.54867 16 7.99998 16C9.45144 16 10.7901 15.6424 12.0157 14.9273ZM7.53136 12.1982L2.80196 7.4689C2.67014 7.33693 2.60392 7.18081 2.60392 7.00018C2.60392 6.8195 2.6701 6.66323 2.80196 6.53134L3.86478 5.46885C3.9966 5.33688 4.15294 5.27088 4.3335 5.27088C4.51378 5.27088 4.67034 5.33688 4.80223 5.46885L8.00002 8.6669L11.198 5.46871C11.3297 5.33674 11.4861 5.27074 11.6666 5.27074C11.8472 5.27074 12.0034 5.33674 12.1353 5.46871L13.1981 6.53119C13.33 6.66323 13.396 6.81935 13.396 7.00003C13.396 7.18063 13.33 7.3369 13.1981 7.46887L8.46889 12.1982C8.33703 12.33 8.18073 12.3959 8.00016 12.3959C7.81953 12.3959 7.66319 12.33 7.53136 12.1982Z"
        fill="#9AA4B1"
      />
    </g>
    <defs>
      <clipPath id="clip0_511:626">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(16) rotate(90)"
        />
      </clipPath>
    </defs>
  </BaseIcon>
);

/*
 * V3 design-system icons. Mirrors `Icon` from
 * `@skandiam/aosphere-nextgenui-component/icons`, which this app doesn't
 * depend on. Paths are ported verbatim from Remix Icon (the source of that
 * registry); `link` is the library's custom LinkIcon. All paths sit on a
 * 24x24 grid and fill with `currentColor`, so they follow the text colour.
 */
const V3_ICON_PATHS = {
  close:
    'M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z',
  excel:
    'M13.2 12L16 16H13.6L12 13.7143L10.4 16H8L10.8 12L8 8H10.4L12 10.2857L13.6 8H15V4H5V20H19V8H16L13.2 12ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z',
  fileWord:
    'M17 19H20V4.99997H17V2.99997H21C21.5523 2.99997 22 3.44769 22 3.99997V20C22 20.5523 21.5523 21 21 21H17V19ZM2.85858 2.87732L15.4293 1.0815C15.7027 1.04245 15.9559 1.2324 15.995 1.50577C15.9983 1.52919 16 1.55282 16 1.57648V22.4235C16 22.6996 15.7761 22.9235 15.5 22.9235C15.4763 22.9235 15.4527 22.9218 15.4293 22.9184L2.85858 21.1226C2.36593 21.0522 2 20.6303 2 20.1327V3.86727C2 3.36962 2.36593 2.9477 2.85858 2.87732ZM4 4.73457V19.2654L14 20.694V3.30599L4 4.73457ZM11 7.99997H13V16H11L9 14L7 16H5V7.99997H7L7.01083 13L9 11L11 12.989V7.99997Z',
  link:
    'M18.3643 15.5353L16.95 14.1211L18.3643 12.7069C20.3169 10.7543 20.3169 7.58847 18.3643 5.63585C16.4116 3.68323 13.2458 3.68323 11.2932 5.63585L9.87898 7.05007L8.46477 5.63585L9.87898 4.22164C12.6127 1.48797 17.0448 1.48797 19.7785 4.22164C22.5121 6.95531 22.5121 11.3875 19.7785 14.1211L18.3643 15.5353ZM15.5358 18.3638L14.1216 19.778C11.388 22.5117 6.9558 22.5117 4.22213 19.778C1.48846 17.0443 1.48846 12.6122 4.22213 9.87849L5.63634 8.46428L7.05055 9.87849L5.63634 11.2927C3.68372 13.2453 3.68372 16.4112 5.63634 18.3638C7.58896 20.3164 10.7548 20.3164 12.7074 18.3638L14.1216 16.9496L15.5358 18.3638ZM14.8287 7.75717L16.2429 9.17139L9.17187 16.2425L7.75766 14.8282L14.8287 7.75717Z',
  pdf:
    'M5 4H15V8H19V20H5V4ZM3.9985 2C3.44749 2 3 2.44405 3 2.9918V21.0082C3 21.5447 3.44476 22 3.9934 22H20.0066C20.5551 22 21 21.5489 21 20.9925L20.9997 7L16 2H3.9985ZM10.4999 7.5C10.4999 9.07749 10.0442 10.9373 9.27493 12.6534C8.50287 14.3757 7.46143 15.8502 6.37524 16.7191L7.55464 18.3321C10.4821 16.3804 13.7233 15.0421 16.8585 15.49L17.3162 13.5513C14.6435 12.6604 12.4999 9.98994 12.4999 7.5H10.4999ZM11.0999 13.4716C11.3673 12.8752 11.6042 12.2563 11.8037 11.6285C12.2753 12.3531 12.8553 13.0182 13.5101 13.5953C12.5283 13.7711 11.5665 14.0596 10.6352 14.4276C10.7999 14.1143 10.9551 13.7948 11.0999 13.4716Z',
} as const;

export type IconName = keyof typeof V3_ICON_PATHS;

/** Same presets as the V3 Icon `size` prop (in px). */
const V3_ICON_SIZES = {
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
} as const;

interface V3IconProps extends Omit<React.SVGProps<SVGSVGElement>, 'ref'> {
  readonly name: IconName;
  readonly size?: keyof typeof V3_ICON_SIZES;
}

export const Icon = ({ name, size = 'lg', ...props }: V3IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    width={V3_ICON_SIZES[size]}
    height={V3_ICON_SIZES[size]}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d={V3_ICON_PATHS[name]} />
  </svg>
);
